<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">  
        <app-data
          titulo="Información del Indicador"
          :datos="indicadorDatos">
        </app-data>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="data-goback-btn" @click.prevent="goBack">
          <i class="fa fa-undo fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Data from  '../shared/tableData.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'indicadorPorcentaje/getField',
  mutationType: 'indicadorPorcentaje/updateField',
});

export default {
  name: 'IndicadoresGastosDatos',
  components: {
    appData: Data,
    appMensaje: Mensaje,
  },
  mixins: [
    msjModal, 
  ],
  data: () => {
    return {
      indicadorId: 0,
    }
  },
  computed: {
    ...mapFields([
      'indicadorDatos',
    ]),
  },
  created() {
    this.indicadorId = this.$route.params.id;

    let params = {
      controller: 'indicadores-gastos',
      indicadorId: this.indicadorId
    }

    this.$store.dispatch('indicadorPorcentaje/getDatos', params)
      .catch(error => this.showErrorMsj(error));
  },  
  methods: {
    goBack() {
      this.$router.push({ name: 'IndicadoresGastos' });
    },
  }
}
</script>
